import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import RentAffordabilityCalculator from "./RentAffordabilityCalculator.esm.js";
const RentAffordabilityCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      monthlyNetIncome = "8700",
      monthlyDebts = "0",
      monthlySavings = "0",
      monthlyExpenses = "0"
    } = attrs;
    const defaultValues = {
      monthlyNetIncome,
      monthlyDebts,
      monthlySavings,
      monthlyExpenses
    };
    return /* @__PURE__ */ jsx(
      RentAffordabilityCalculator,
      {
        ...defaultValues
      },
      isEditor() ? JSON.stringify(defaultValues) : void 0
    );
  },
  metadata: {
    version: "1.0",
    name: "constellation/rent-affordability-calculator",
    title: "Rent Affordability Calculator",
    description: "Calculate your rent",
    icon: "calculator",
    keywords: ["rentals", "calculators", "affordability"],
    category: "Calculators",
    attributes: {
      monthlyNetIncome: {
        type: "string",
        default: "8700",
        label: "Default Monthly Net Income",
        control: "text"
      },
      monthlyDebts: {
        type: "string",
        default: "0",
        label: "Default Monthly Debts",
        control: "text"
      },
      monthlySavings: {
        type: "string",
        default: "0",
        label: "Default Monthly Savings",
        control: "text"
      },
      monthlyExpenses: {
        type: "string",
        default: "0",
        label: "Default Monthly Expenses",
        control: "text"
      }
    }
  }
};
export {
  RentAffordabilityCalculatorBlock as default
};
